import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'Event sent when a user completes the onboarding upload step',
  name: 'completed_onboarding_upload',
};

export default META;
